(() => {
  const root = document.querySelector("[data-tfm-guide]");
  if (!root) return;

  const body = root.querySelector("[data-tfm-guide-body]");
  const toc = root.querySelector("[data-tfm-guide-toc]");
  const tocList = root.querySelector("[data-tfm-guide-toc-list]");
  if (!body || !toc || !tocList) return;

  const slugify = (text) =>
    text
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/(^-|-$)/g, "")
      .slice(0, 64) || "section";

  // Drop redundant meta / CTA lines kept in legacy page HTML
  Array.from(body.querySelectorAll("p")).forEach((p) => {
    const html = p.innerHTML || "";
    const text = (p.textContent || "").trim();
    const isMeta =
      /<em>\s*Durée\s*<\/em>/i.test(html) ||
      (/Durée/i.test(text) && /Format/i.test(text));
    const isCtaRow =
      (/Voir le produit/i.test(text) || /Voir Meeting|Voir Signals|Voir /i.test(text)) &&
      (/Tous les guides/i.test(text) || p.querySelectorAll("a").length >= 1) &&
      text.length < 160;
    const isProductList =
      /^Produits\s*:/i.test(text) && p.querySelectorAll('a[href*="/products/"]').length > 0;
    if (isMeta || isCtaRow || isProductList) p.remove();
  });

  const headings = Array.from(body.querySelectorAll("h2"));
  if (!headings.length) return;

  const used = new Set();
  headings.forEach((h2) => {
    let id = h2.id || slugify(h2.textContent || "section");
    let n = 2;
    const base = id;
    while (used.has(id) || document.getElementById(id)) {
      id = `${base}-${n}`;
      n += 1;
    }
    used.add(id);
    h2.id = id;

    const li = document.createElement("li");
    const a = document.createElement("a");
    a.href = `#${id}`;
    a.textContent = (h2.textContent || "").trim();
    li.appendChild(a);
    tocList.appendChild(li);
  });

  toc.hidden = false;
})();
